// extracted by mini-css-extract-plugin
module.exports = {"main-card":"card_main-card__3mxLz","header-card":"card_header-card__2maMZ","inci":"card_inci__Z4PuA","card-mini-des":"card_card-mini-des__2iZYs","card-des":"card_card-des__1S4y4"};